
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/landings/[slug]",
      function () {
        return require("private-next-pages/[locale]/landings/[slug].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/landings/[slug]"])
      });
    }
  